import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "view-pdf",
  templateUrl: "./viewPdf.component.html",
  styleUrls: ["./viewPdf.component.scss"],
})
export class ViewPdfComponent implements OnInit {
  @Input() data;
  pdfUrl
  constructor(
    public activeModal: NgbActiveModal,
    
    ) {}
    ngOnInit() {
      this.pdfUrl = this.data
  }
  closeModal() {
    this.activeModal.dismiss();
  }
  downloadPdf() {
    downloadPdf(this.pdfUrl)
  }
}

export function downloadPdf(pdfUrl){
  fetch(pdfUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'document.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => console.error('Error downloading PDF:', error));
}